import { ExpertAnketaAnswerSelect } from './ExpertAnketaAnswerSelect';

export default ExpertAnketaAnswerSelect;